import instoreHiwModal from './instoreHiwModal';

export default instoreHiwModal;
